import React from 'react'
import PropTypes from 'prop-types'

import closeIcon from 'resources/close_icon.png'

export default class EstimateHeader extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    onCloseClicked: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={styles.header}>
        <div style={styles.heading}>
          {this.props.title}
        </div>
        <div style={{ marginRight: 32 }}>
          <img src={closeIcon} title='Close' width={16}
            onClick={this.props.onCloseClicked}
            style={{ cursor: 'pointer' }} />
        </div>
      </div>
    )
  }

}

const styles = {
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 32,
    color: '#212121'
  }
}



// WEBPACK FOOTER //
// ./src/billing/estimates/EstimateHeader.js